import React, { FC, useState } from "react";
import { observer } from "mobx-react-lite";
import { makeStyles, Box, TextField, Checkbox } from "@material-ui/core";
import { Link } from "react-router-dom";
import Button from "./Button";
import { Text } from "../components/Text";
import { store } from "../store";
import { useIdentityContext } from "react-netlify-identity";

export const SignUpAction: FC = observer(() => {
  const { isLoggedIn, signupUser } = useIdentityContext();
  const [errors, setErrors] = useState([]);
  const {
    inputEmail,
    password,
    isEmailValid,
    joinMailingList,
    toggleJoinMailing,
    getLocalDesigns,
  } = store;
  const classes = styles();

  const handleSignUp = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let allErrors = [];
    if (!isEmailValid) allErrors.push("Please enter a valid email address");
    if (password.length < 6)
      allErrors.push("Your password must be more than 6 characters");
    setErrors(allErrors);
    if (!allErrors.length) {
      await signup();
    }
    return false;
  };

  const signup = async () => {
    try {
      const user = await signupUser(inputEmail, password, {});
      console.log("Successfully signed up", user);
      try {
        const designs = getLocalDesigns();
        await fetch(`/.netlify/functions/PostSignUp`, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: user.id,
            insertedIds: designs.map(({ result }) =>
              typeof result === "string" ? JSON.parse(result)._id : result._id
            ),
            email: inputEmail,
            joinMailingList,
          }),
        });
      } catch (e) {
        console.log(e);
      }

      setErrors([]);
    } catch (err) {
      console.log("Failed to sign up user", err);
      const error = err?.json?.msg || "An error ocurred";
      setErrors([error]);
    }
  };

  if (isLoggedIn) return null;
  return (
    <Box id="signup" m={4} maxWidth={530} width={1}>
      <Text align="center" gutterBottom bold size="large">
        Be sure to create an account to save your results.
      </Text>
      <form onSubmit={handleSignUp}>
        <Box className={classes.inputContainer}>
          <TextField
            InputProps={{ classes: { input: classes.input } }}
            placeholder="EMAIL"
            className={classes.input}
            type="email"
            value={inputEmail}
            name="inputEmail"
            error={!!errors.find((err) => err.includes("email"))}
            variant="filled"
            onChange={(e) =>
              (store[e.currentTarget.name] = e.currentTarget.value)
            }
          />
        </Box>
        <Box className={classes.inputContainer}>
          <TextField
            InputProps={{ classes: { input: classes.input } }}
            placeholder="PASSWORD"
            className={classes.input}
            type="password"
            value={password}
            name="password"
            error={!!errors.find((err) => err.includes("password"))}
            variant="filled"
            onChange={(e) =>
              (store[e.currentTarget.name] = e.currentTarget.value)
            }
          />
        </Box>
        <Box display="flex" className={classes.inputContainer}>
          <Checkbox checked={joinMailingList} onChange={toggleJoinMailing} />
          <Box>
            Join our mailing list to receive information on new product updates,
            information and special offers
          </Box>
        </Box>
        <Box className={classes.errors}>
          {errors.map((error) => (
            <Text size="small" color="error" key={error}>
              {error}
              {error.includes("already been registered") && (
                <>
                  <br />
                  If this is your account, <Link to="/login">login here</Link>
                </>
              )}
            </Text>
          ))}
        </Box>
        <Button type="submit">SIGN UP</Button>
      </form>
    </Box>
  );
});

const styles = makeStyles((theme) => ({
  inputContainer: {
    margin: "20px 0px",
  },
  errors: {
    marginBottom: 20,
  },
  input: {
    width: "100%",
    background: "white",
  },
}));
